export default __webpack_public_path__ + "static/media/slider-bnr.81f11b70.jpg";